<mat-form-field appearance="outline" #formControl fxFlex="98" fxFlex.md="96" fxFlex.sm="96" fxFlex.xs="94" style="height: 40px;" class="dateform">
    <input matInput [matDatepicker]="$any(datepicker)" placeholder="{{config.DatePlaceholder}}"
        [formControl]="dateControl" class="date-picker2" readonly
        [max]="$any(config.maximumDate)" [min]="$any(config.minimumDate)" [matDatepickerFilter]="$any(config.dateFilter)"
        (dateInput)="inputEvent($event)" (dateChange)="changeEvent($event)"  (click)="openDatePicker()" required="{{isRequired}}">

    <div class="date-picker-options">
        <mat-datepicker-toggle *ngIf="!config.removeTodaysIcon" matSuffix (click)="today()" style="float:right;"
            matTooltip="{{config.TodayButtonTooltip}}">
            <mat-icon matDatepickerToggleIcon class="icon-calendar-today" ></mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker-toggle matSuffix (click)="clearDate()" style="float:right;"
            matTooltip="{{config.ClearButtonTooltip}}">
            <mat-icon matDatepickerToggleIcon  class="icon-close" id="clearDate"></mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #datepicker (opened)="onOpen()" [startView]="$any(config.startView)" [startAt]="$any(config.startDate)"
                        [dateClass]="$any(config.dateClass)"></mat-datepicker>

    </div>
</mat-form-field>

<!-- Workaround for adding the buttons -->
<div style="display: none" *ngIf="!config.removeTodaysIcon">
    <div class="datepicker-footer" #datepickerFooter>
        <button type="button" mat-raised-button color="primary" (click)="today()" #todayButton
            matTooltip="{{config.TodayButtonTooltip}}" id="todayButton">
            {{config.TodayButtonLabel}}
        </button>

        
    </div>
</div>
